<template>
  <v-text-field
    :type="passwordVis ? 'text' : 'password'"
    :append-inner-icon="!passwordVis ? 'mdi-eye-off' : 'mdi-eye'"
    @click:append-inner="passwordVis = !passwordVis"
  ></v-text-field>
</template>

<script setup lang="ts">
import { ref } from "vue";

const passwordVis = ref(false);
</script>
